/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Manage_ButtonInputs */



/**
* | output |
* | --- |
* | "Manage Speakers" |
*
* @param {Insert_Speaker_Manage_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_manage_button = /** @type {((inputs?: Insert_Speaker_Manage_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Manage_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer les locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci gli altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление спикерами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं का प्रबंधन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar Oradores")
	return /** @type {LocalizedString} */ ("Manage Speakers")
});